import React from 'react'
import { observer } from 'mobx-react-lite'
import { sideNavAnalyticsProps } from '../side-nav-analytics-props'
import { useIsActive } from 'app/packs/src/utils/use-is-active'
import * as SideMenu from 'components/side-menu'
import { useStore } from 'store/context'

export const WinsLink = observer(() => {
  const { currentUser } = useStore()

  const path = `/wins`
  const title = 'Wins'

  const isActive = useIsActive(path, null, { exactMatch: false })

  // Hidden where an admin has switched Wins off for the account. The controller
  // redirects anyone who reaches the URL back to root, and a side-nav click
  // navigates a turbo frame that cannot paint that flash, so an offered link
  // just looks dead.
  if (!currentUser?.org?.winsEnabled) return null

  return (
    <SideMenu.LinkItem
      active={isActive}
      analyticsProps={sideNavAnalyticsProps({
        title,
        href: path,
      })}
      href={path}
    >
      {title}
    </SideMenu.LinkItem>
  )
})
